<template>
  <div class="sitemap">
    <sitemap />
  </div>
</template>

<script>

import sitemap from 'components/sitemap'
import style from 'styles/about.scss'

export default {
  name: 'about',
  components: {
    sitemap
  }
}
</script>




// WEBPACK FOOTER //
// apps/www.bravenet.com/src/views/sitemap.vue